import { render } from "./NotificationsPanel.vue?vue&type=template&id=54b44cbc&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"

import "./NotificationsPanel.vue?vue&type=style&index=0&id=54b44cbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b44cbc"]])

export default __exports__